// extracted by mini-css-extract-plugin
export default {"root":"_4f2mvJRZ","marked":"_94hMt30F","soon":"_3sJcAJ-2","active":"_2uQ6ngW3","iconContainer":"_1PI1JOmK"};